import {
    blockSendersTitle,
    blockTwoSendersTitle,
    blockThreeSendersTitle,
    blockFourToSixSendersTitle,
    blockSevenOrMoreSendersTitle,
    blockSendersSubtext,
    blockTwoSendersSubtext,
    blockThreeSendersSubtext,
    blockFourToSixSendersSubtext,
    blockSevenOrMoreSendersSubtext,
} from './getBlockSendersConfirmTitleAndSubtext.locstring.json';
import loc, { format } from 'owa-localize';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

export default function getBlockSendersConfirmTitleAndSubtext(
    emailAddresses: EmailAddressWrapper[]
): [string, string] {
    return [title(emailAddresses), subtext(emailAddresses)];
}

function title(emailAddresses: EmailAddressWrapper[]): string {
    return formatSenders(
        emailAddresses,
        e => e.Name,
        loc(blockSendersTitle),
        loc(blockTwoSendersTitle),
        loc(blockThreeSendersTitle),
        loc(blockFourToSixSendersTitle),
        loc(blockSevenOrMoreSendersTitle)
    );
}

function subtext(emailAddresses: EmailAddressWrapper[]): string {
    return formatSenders(
        emailAddresses,
        e => e.EmailAddress,
        loc(blockSendersSubtext),
        loc(blockTwoSendersSubtext),
        loc(blockThreeSendersSubtext),
        loc(blockFourToSixSendersSubtext),
        loc(blockSevenOrMoreSendersSubtext)
    );
}

function formatSenders(
    emailAddresses: EmailAddressWrapper[],
    toText: (e: EmailAddressWrapper) => string,
    oneSender: string,
    twoSenders: string,
    threeSenders: string,
    fourToSixSenders: string,
    sevenOrMoreSenders: string
): string {
    switch (emailAddresses.length) {
        case 0:
            throw new Error('formatSenders: no email addresses');
        case 1:
            return format(oneSender, toText(emailAddresses[0]));
        case 2:
            return format(twoSenders, toText(emailAddresses[0]), toText(emailAddresses[1]));
        case 3:
            return format(threeSenders, toText(emailAddresses[0]), toText(emailAddresses[1]));
        case 4:
        case 5:
        case 6:
            return format(
                fourToSixSenders,
                toText(emailAddresses[0]),
                toText(emailAddresses[1]),
                emailAddresses.length - 2
            );
        default:
            return format(
                sevenOrMoreSenders,
                toText(emailAddresses[0]),
                toText(emailAddresses[1]),
                emailAddresses.length - 2
            );
    }
}
